import { PatientImmunizationsConstants } from '../store/patientImmunizations.constants'

export const patientImmunizationsSchemas = [
  {
    inputKey: PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,200}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON'],
    errorMessage: {
      properties: {
        SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON: 'Must be alphanumeric with max length of 200',
      },
    },
  },
  {
    inputKey: PatientImmunizationsConstants.SET_OTHERNAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_OTHERNAME: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_OTHERNAME'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_OTHERNAME: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: PatientImmunizationsConstants.SET_UPTODATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_UPTODATE: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_UPTODATE'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_UPTODATE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATION_TYPE,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_PATIENT_IMMUNIZATION_TYPE: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_PATIENT_IMMUNIZATION_TYPE'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_PATIENT_IMMUNIZATION_TYPE: 'error',
      },
    },
  },
  {
    inputKey: PatientImmunizationsConstants.SET_IMMUNIZATIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_IMMUNIZATIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_IMMUNIZATIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_IMMUNIZATIONS: 'error',
      },
    },
  },
]
